import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import {
  CreateConsignmentRequest, CreateConsignmentServiceRequest,
  CountNewConsignmentRequest, CountNewConsignmentDto,
  CountOpenConsignmentRequest, CountOpenConsignmentDto,
  CountExceptionConsignmentRequest, CountExceptionConsignmentDto,
  CountDiscrepancyConsignmentRequest, CountDiscrepancyConsignmentDto,
  ConsignmentRequest
} from '.';
import { API } from '../config/api';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { SUCCESS, GOOGLEMAP_KEY } from 'src/@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { Consignment, ConsignmentServiceModel  } from '../../models';
import { requestQuery } from '../../../@shared/untils';
import { Observable, of } from 'rxjs';
import { ConsignmentOverviewRequest } from '../customer/customer.DTO';

@Injectable()
export class ConsignmentService {
  constructor(private _http: HttpClient,
    private _spinner: BoSpinnerService,
    private _toastr: BoToastrService) {
  }

  public create(model: CreateConsignmentServiceRequest) {
    return this._http.post(`${API.CONSIGNMENT.CREATE}`, model)
      //return this._http.get(`${API.CONSIGNMENT.CREATE}`)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_CONSIGNMENT);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  public bookHxLoadOveride(consignmentId: string, loadId: number, quoteId: number, companyToUse: number, agreedRate: number) {
    // const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    //return this._http.post('${API.INTEGRATION.BOOK_HX_LOADFROMQUOTEOVERIDE(consignmentId, loadId, quoteId, companyToUse, agreedRate)}',null);
    return this._http.post(`${API.CONSIGNMENT.BOOK_HX_LOADFROMQUOTEOVERIDE(consignmentId, loadId, quoteId, companyToUse, agreedRate)}`, null);
  }
  public processCustomerOnHold(consignmentId: string) {
    return this._http.post(`${API.CONSIGNMENT.PROCESS_CUSTOMER_ON_HOLD.GENERATE_OVERRIDE_PASSWORD(consignmentId)}`, null);
  }

  public validateOverridePassword(consignmentId: string, overridePassword: string) {
    return this._http.post(`${API.CONSIGNMENT.PROCESS_CUSTOMER_ON_HOLD.VALIDATE_OVERRIDE_PASSWORD(consignmentId, overridePassword)}`, null);
  }

  public getPalletServiceLevel(collectionPostCode: string, customerId: string) {
    return this._http.get(`${API.CONSIGNMENT.GET_SERVICE_LEVEL.PALLET}?collectionPostCode=${collectionPostCode}&customerId=${customerId}`).pipe(tap(() => this._spinner.hide()));
  }
  public updateConsignment2(model: CreateConsignmentRequest, id: string) {
    return this._http.put(API.CONSIGNMENT.UPDATE(id), model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.UPDATE_CONSIGNMENT);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }
  public updateConsignment3(model: CreateConsignmentRequest, id?) {
    this._spinner.show();
    return this._http.put(`${API.CONSIGNMENT.UPDATE_CONSIGNMENT3}?id=${id}`, model)
      .pipe(
        tap(() => {
          this._spinner.hide();
          this._toastr.successCode(SUCCESS.UPDATE_CONSIGNMENT);
        }),
        catchError((err: ErrorResponse) => {
          this._spinner.hide();
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }
  public getOneConsignment(id: string) {
    return this._http.get<Consignment>(`${API.CONSIGNMENT.GET_ONE(id)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public generatePrice(id: string, supplierID: string, miles: number) {
    return this._http.get(`${API.CONSIGNMENT.GENERATE_PRICE}?id=${id}&supplierID=${supplierID}&miles=${miles}`)
      .pipe(
        tap(() => {
          this._spinner.hide();
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  public calculateCheapestSupplier(id: string) {
    return this._http.get(API.CONSIGNMENT.CALCULATE_CHEAPEST_SUPPLIER(id))
      .pipe(
        tap(() => {
          this._spinner.hide();
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  // Consignment Quotation
  public createConvertQuotation(model: CreateConsignmentRequest) {
    return this._http.post(`${API.CONSIGNMENT.CREATE}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_CONSIGNMENT);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }
  public convertQuotation(model: CreateConsignmentRequest, id?) {
    return this._http.put(`${API.CONSIGNMENT.UPDATE_CONSIGNMENT3}?id=${id}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CONVERT_QUOTATION);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }
  public countNewConsignment(request: CountNewConsignmentRequest, disableSpinner?: boolean)
    : Observable<Array<CountNewConsignmentDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }

    return this._http.get<Array<CountNewConsignmentDto>>(`${API.CONSIGNMENT.COUNT_NEW_JOB}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public countOpenConsignment(request: CountOpenConsignmentRequest, disableSpinner?: boolean)
    : Observable<Array<CountOpenConsignmentDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }

    return this._http.get<Array<CountOpenConsignmentDto>>(`${API.CONSIGNMENT.COUNT_OPEN_JOB}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public countExceptionConsignment(request: CountExceptionConsignmentRequest, disableSpinner?: boolean)
    : Observable<Array<CountExceptionConsignmentDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }

    return this._http.get<Array<CountExceptionConsignmentDto>>(`${API.CONSIGNMENT.COUNT_EXCEPTION_JOB}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public countDiscrepancyConsignment(request: CountDiscrepancyConsignmentRequest, disableSpinner?: boolean)
    : Observable<Array<CountDiscrepancyConsignmentDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }

    return this._http.get<Array<CountDiscrepancyConsignmentDto>>(`${API.CONSIGNMENT.COUNT_DISCREPANCY_JOB}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public getConsignments(request: ConsignmentRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<Consignment>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }

    return this._http.get<PaginationResponse<Consignment>>(
      `${API.CONSIGNMENT.GET_CONSIGNMENT}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  
  public getConsignmentsForCust(request: ConsignmentRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<Consignment>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }

    return this._http.get<PaginationResponse<Consignment>>(
      `${API.CONSIGNMENT.GET_CONSIGNMENTFORCUST}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public changeStatus(id: string, status: number) {
    return this._http.put(API.CONSIGNMENT.CHANGE_STATUS(id, status), '')
      .pipe(
        tap((data) => {
          this._toastr.successCode(SUCCESS.UPDATE_CONSIGNMENT);
          return data;
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }
  public deleteConsignment(id: string) {
    return this._http.delete(`${API.CONSIGNMENT.DELETE(id)}`);
  }

  public printEndDayManifest(printDate: string) {
    return this._http
      .post(API.SERVER_PRINT.PRINT_ENDDAY_MANIFEST, { printDate: printDate }, { responseType: 'blob' })
      .pipe(tap(() => this._spinner.hide()));
  }

  public printAllConsignmentReport(printAllConsignmentRequest: any) {
    return this._http
      .get(`${API.SERVER_PRINT.PRINT_ALL_CONSIGNMENTS}`, {
        params: printAllConsignmentRequest,
        responseType: 'blob',
      })
      .pipe(tap(() => this._spinner.hide()));
  }

  public printAllDriverConsignmentReport(printAllConsignmentRequest: any) {
    return this._http
      .get(`${API.SERVER_PRINT.PRINT_ALL_DRIVER_CONSIGNMENT}`, {
        params: printAllConsignmentRequest,
        responseType: 'blob',
      })
      .pipe(tap(() => this._spinner.hide()));
  }

  public printCOnsignmentSummary(id: string) {
    return this._http
      .get(API.SERVER_PRINT.CONSIGNMENT_SUMMARY(id), { responseType: 'blob' })
      .pipe(tap(() => this._spinner.hide()));
  }

  public GetMiGoogleMap(origins, destinations) {
    return this._http.get(`https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=${origins}&destinations=${destinations}&key=${GOOGLEMAP_KEY}`);
  }

  public getPrintAllConsignment(id: string, request: ConsignmentOverviewRequest) {
    return this._http.get(`${API.CONSIGNMENT.PRINT.PRINT_ALL(id)}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getPrintPackagesConsignment(id: string, request: ConsignmentOverviewRequest) {
    return this._http.get(`${API.CONSIGNMENT.PRINT.PRINT_PACKAGES(id)}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getPrintPalletsConsignment(id: string, request: ConsignmentOverviewRequest) {
    return this._http.get(`${API.CONSIGNMENT.PRINT.PRINT_PALLETS(id)}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getPrintLabelForSupplier(id: string, dateFrom: Date, dateTo: Date) {
    return this._http.get(`${API.SERVER_PRINT.SUPPLIER_LABEL}?${requestQuery({
      dateFrom: dateFrom.toJSON(),
      dateTo: dateTo.toJSON(),
      supplierID: id
    })}`, { responseType: 'blob' }).pipe(tap(() => this._spinner.hide()));
  }

  public getLabelMultiple(ids: string[]) {
    const params = {
      consignmentIds: ids
    };
    return this._http.get(API.SERVER_PRINT.LABEL_MULTIPLE, { params: params, responseType: 'blob' });
  }

  public getCustomerPortalDashboard(statisticDate: Date) {
    return this._http.get(`${API.CONSIGNMENT.CUSTOMER_PORTAL_DASHBOARD()}?${requestQuery({
      statisticDate: statisticDate.toJSON()
    })}`).pipe(tap(() => this._spinner.hide()));
  }
}
